<template>
  <div class="collection-tabs">
    <div
      class="collection-tab"
      :class="{ 'collection-tab-active': $route.name === 'Home' }"
      @click="$navigateTo({ name: 'Home' })">
      Home
    </div>
    <div
      class="collection-tab"
      :class="{ 'collection-tab-active': $route.name === 'HowToUse' }"
      @click="$navigateTo({ name: 'HowToUse' })">
      How to use
    </div>
    <div
      class="collection-tab"
      :class="{ 'collection-tab-active': $route.name === 'CollectionManagement' }"
      @click="$navigateTo({ name: 'CollectionManagement' })">
      Collections
    </div>
    <div
      class="collection-tab"
      :class="{ 'collection-tab-active': $route.name === 'AccountManagement' }"
      @click="$navigateTo({ name: 'AccountManagement' })">
      Account
    </div>
    <div class="collection-tab-filler" />
  </div>
</template>

<script>
export default {
  name: 'HomeNavigation',
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';

.collection-tabs {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  z-index: 5;
  border-bottom: 1px solid $primary;
  font-size: 1.25rem;
  height: 2.875rem; // (font-size * 1.5 line-height) + 0.5 padding + 1px for border
  padding: 0 0 0 0.75rem !important;
  vertical-align: middle;
  user-select: none;
}
.collection-tab {
  flex: 0 0 auto;
  margin: 0 0 -1px 0;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
}
.collection-tab-active {
  font-weight: 600;
}
</style>
